import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function GettingStarted() {
  const navigate = useNavigate();
  const [locationId, setLocationId] = useState('');
  const [appUrl, setAppUrl] = useState('');

  useEffect(() => {
    // Get location_id from query parameters
    const params = new URLSearchParams(window.location.search);
    const locId = params.get('location_id');

    if (locId) {
      setLocationId(locId);
      // Construct the app URL
      const url = `/app?location_id=${encodeURIComponent(locId)}`;
      setAppUrl(url);
    }
  }, []);

  const handleOpenApp = () => {
    if (appUrl) {
      window.location.href = appUrl;
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Getting Started</h1>
        <p style={styles.subtitle}>
          You're ready to launch Inbox Sentinel. Click below to open the app.
        </p>

        <button
          style={styles.btn}
          onClick={handleOpenApp}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 10px 20px rgba(37, 99, 235, 0.35)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Open Inbox Sentinel
        </button>

        <div style={styles.note}>
          If the app doesn't load, refresh this page.
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: 'linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%)',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    color: '#1a202c',
  },
  card: {
    background: '#ffffff',
    borderRadius: '14px',
    boxShadow: '0 20px 50px rgba(26, 32, 44, 0.2)',
    maxWidth: '560px',
    width: '100%',
    padding: '40px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2rem',
    marginBottom: '12px',
    margin: '0',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#4a5568',
    marginBottom: '28px',
    lineHeight: '1.6',
    margin: '0 0 28px 0',
  },
  btn: {
    display: 'inline-block',
    background: '#2563eb',
    color: '#ffffff',
    padding: '14px 28px',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '1rem',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: 'none',
    cursor: 'pointer',
  },
  note: {
    marginTop: '16px',
    fontSize: '0.9rem',
    color: '#718096',
  },
};
